import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CarouselWrapper } from "./carousel-type-fade.styles";
import { Item } from "./item";
import { jsx as _jsx } from "react/jsx-runtime";
export var CarouselTypeFade = function CarouselTypeFade(_ref) {
  var children = _ref.children,
    currentIndex = _ref.currentIndex;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    wrapperHeight = _useState2[0],
    setWrapperHeight = _useState2[1];
  return /*#__PURE__*/_jsx(CarouselWrapper, {
    height: wrapperHeight,
    children: React.Children.toArray(children).map(function (child, index) {
      return /*#__PURE__*/_jsx(Item, {
        child: child,
        currentIndex: currentIndex,
        index: index,
        updateWrapperHeight: setWrapperHeight
      }, "carousel-type-fade-item-".concat(index));
    })
  });
};
CarouselTypeFade.propTypes = {
  children: PropTypes.node.isRequired,
  currentIndex: PropTypes.number.isRequired,
  transitions: PropTypes.object
};
CarouselTypeFade.defaultProps = {
  transitions: {}
};